var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCopy(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 25,
    height: 24,
    viewBox: "0 0 25 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "CopySimple"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M16.875 6H3.75C3.45163 6 3.16548 6.11853 2.9545 6.3295C2.74353 6.54048 2.625 6.82663 2.625 7.125V20.25C2.625 20.5484 2.74353 20.8345 2.9545 21.0455C3.16548 21.2565 3.45163 21.375 3.75 21.375H16.875C17.1734 21.375 17.4595 21.2565 17.6705 21.0455C17.8815 20.8345 18 20.5484 18 20.25V7.125C18 6.82663 17.8815 6.54048 17.6705 6.3295C17.4595 6.11853 17.1734 6 16.875 6ZM15.75 19.125H4.875V8.25H15.75V19.125ZM21.375 3.75V16.875C21.375 17.1734 21.2565 17.4595 21.0455 17.6705C20.8345 17.8815 20.5484 18 20.25 18C19.9516 18 19.6655 17.8815 19.4545 17.6705C19.2435 17.4595 19.125 17.1734 19.125 16.875V4.875H7.125C6.82663 4.875 6.54048 4.75647 6.3295 4.5455C6.11853 4.33452 6 4.04837 6 3.75C6 3.45163 6.11853 3.16548 6.3295 2.9545C6.54048 2.74353 6.82663 2.625 7.125 2.625H20.25C20.5484 2.625 20.8345 2.74353 21.0455 2.9545C21.2565 3.16548 21.375 3.45163 21.375 3.75Z",
    fill: "#94A3B8"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCopy);
export default __webpack_public_path__ + "static/media/copy.7f7f1cbd2b33101c045322929112255c.svg";
export { ForwardRef as ReactComponent };